var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TitleCard',{attrs:{"title":_vm.cardTitle,"showMore":_vm.showMore}},[_c(_vm.pageComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }